/**
 * Broker Types
 *
 * Types for distribution brokers and their outputs.
 */
// ============ Broker Types ============
export const BROKER_TYPES = [
    "nimble",
    "aws_mediaconnect",
    "srt_gateway",
];
export const BROKER_TYPE_LABELS = {
    nimble: "Nimble Streamer",
    aws_mediaconnect: "AWS MediaConnect",
    srt_gateway: "SRT Gateway",
};
// ============ Output Types ============
export const OUTPUT_TYPES = [
    "rtmp",
    "srt",
    "hls",
    "zixi",
    "rist",
    "youtube_live",
];
export const OUTPUT_TYPE_LABELS = {
    rtmp: "RTMP",
    srt: "SRT",
    hls: "HLS",
    zixi: "Zixi",
    rist: "RIST",
    youtube_live: "YouTube Live",
};
